export default {
  "title": "إشعار خصوصية الموقع",
  "lastUpdated": "آخر تحديث: ٢٦ مايو ٢٠٢٦",
  "back": "← العودة إلى الصفحة الرئيسية",
  "intro": [
    {
      "type": "h3",
      "text": "نبذة عن إشعار الخصوصية هذا"
    },
    {
      "type": "p",
      "text": "خصوصيتك مهمة بالنسبة لنا."
    },
    {
      "type": "p",
      "text": "يوضح إشعار خصوصية الموقع هذا كيف تجمع Demakstore Gıda İhracat San. ve Tic. Ltd. Şti.، المشغِّلة لعلامة DeMaxtore («DeMaxtore»، «نحن»، «لنا»)، البيانات الشخصية عند استخدامك لـ www.demaxtore.com."
    },
    {
      "type": "p",
      "text": "يشمل ذلك أي بيانات شخصية قد تقدمها عندما:"
    },
    {
      "type": "ul",
      "items": [
        "تزور موقعنا أو تتصفحه",
        "تنشئ حساباً أو تستخدمه",
        "تقدم طلب توريد",
        "تستخدم CommodityBid",
        "تستخدم FreightIQ",
        "تطلب خدمات تفتيش",
        "تطلب دعم تتبع الشحنات المباشر",
        "تتواصل معنا عبر النماذج أو البريد الإلكتروني أو WhatsApp أو الهاتف أو الرسائل القصيرة أو قنوات أخرى",
        "تعرض شركتك أو منتجاتك أو خدماتك عبر منصتنا",
        "تتواصل مع DeMaxtore كمشتري أو مورد أو مصنع أو وسيط شحن أو شريك تفتيش أو شريك تجاري آخر"
      ]
    },
    {
      "type": "p",
      "text": "يشرح هذا الإشعار ما البيانات الشخصية التي نعالجها، ولماذا، ومدة الاحتفاظ بها، ومع من قد نشاركها، وما حقوقك."
    }
  ],
  "sections": [
    {
      "title": "١. من المسؤول عن بياناتك الشخصية؟",
      "blocks": [
        {
          "type": "p",
          "text": "المسؤول عن معالجة بياناتك الشخصية هو:"
        },
        {
          "type": "ul",
          "items": [
            "Demakstore Gıda İhracat San. ve Tic. Ltd. Şti.",
            "العلامة التشغيلية: DeMaxtore",
            "الموقع: www.demaxtore.com",
            "البريد الإلكتروني: support@demaxtore.com",
            "بريد إلكتروني بديل: demaxtore@demaxtore.com"
          ]
        },
        {
          "type": "p",
          "text": "لأغراض هذا الإشعار، تشير DeMaxtore إلى العلامة والمنصة التي تديرها Demakstore Gıda İhracat San. ve Tic. Ltd. Şti."
        }
      ]
    },
    {
      "title": "٢. ما البيانات الشخصية التي نجمعها؟",
      "blocks": [
        {
          "type": "p",
          "text": "قد نجمع ونعالج فئات البيانات الشخصية التالية:"
        },
        {
          "type": "h3",
          "text": "معلومات الهوية"
        },
        {
          "type": "p",
          "text": "قد يشمل ذلك:"
        },
        {
          "type": "ul",
          "items": [
            "الاسم الكامل",
            "اسم ممثل الشركة",
            "صورة الملف الشخصي، إن وُجدت",
            "معلومات الهوية أو التحقق، عندما يقتضي القانون ذلك"
          ]
        },
        {
          "type": "h3",
          "text": "معلومات الاتصال التجارية"
        },
        {
          "type": "p",
          "text": "قد يشمل ذلك:"
        },
        {
          "type": "ul",
          "items": [
            "البريد الإلكتروني التجاري",
            "رقم الهاتف",
            "المسمى الوظيفي",
            "القسم",
            "اسم الشركة",
            "موقع الشركة",
            "البلد والمدينة",
            "عنوان العمل، إن وُجد"
          ]
        },
        {
          "type": "h3",
          "text": "معلومات الشركة والمورد"
        },
        {
          "type": "p",
          "text": "قد يشمل ذلك:"
        },
        {
          "type": "ul",
          "items": [
            "معلومات ملف الشركة",
            "فئات المنتجات",
            "مواصفات المنتج",
            "قدرات التصنيع",
            "الشهادات",
            "تفاصيل التحقق من المورد",
            "دور المشتري أو المورد"
          ]
        },
        {
          "type": "h3",
          "text": "معلومات التوريد والمزايدة"
        },
        {
          "type": "p",
          "text": "قد يشمل ذلك:"
        },
        {
          "type": "ul",
          "items": [
            "طلبات توريد المنتجات",
            "طلبات CommodityBid",
            "الكمية والتعبئة والسعر المستهدف ومتطلبات التسليم",
            "عروض الموردين",
            "مراسلات المشتري والمورد",
            "تفاصيل مقارنة العروض"
          ]
        },
        {
          "type": "h3",
          "text": "معلومات اللوجستيات والشحن"
        },
        {
          "type": "p",
          "text": "قد يشمل ذلك:"
        },
        {
          "type": "ul",
          "items": [
            "تفاصيل طلب الشحن",
            "معلومات الاستلام والتسليم",
            "نوع الشحنة وتفاصيلها",
            "بيانات مقارنة FreightIQ",
            "عروض الوسطاء",
            "تحديثات التتبع",
            "معلومات لوجستية من الباب إلى الباب"
          ]
        },
        {
          "type": "h3",
          "text": "معلومات التفتيش"
        },
        {
          "type": "p",
          "text": "قد يشمل ذلك:"
        },
        {
          "type": "ul",
          "items": [
            "تفاصيل طلب التفتيش",
            "موقع المصنع أو المورد",
            "متطلبات جودة المنتج",
            "تقارير التفتيش",
            "صور ومستندات ومراسلات ذات صلة"
          ]
        },
        {
          "type": "h3",
          "text": "معلومات مالية ومعاملات"
        },
        {
          "type": "p",
          "text": "قد يشمل ذلك:"
        },
        {
          "type": "ul",
          "items": [
            "معلومات الفواتير",
            "سجلات الأعمال المتعلقة بالدفع",
            "تفاصيل بنكية عند الحاجة",
            "معلومات محاسبية وضريبية"
          ]
        },
        {
          "type": "h3",
          "text": "معلومات الامتثال"
        },
        {
          "type": "p",
          "text": "قد يشمل ذلك:"
        },
        {
          "type": "ul",
          "items": [
            "اعرف عميلك / اعرف موردك",
            "فحوصات مكافحة الاحتيال",
            "امتثال التجارة",
            "مكافحة غسل الأموال",
            "مكافحة الرشوة والفساد",
            "فحص العقوبات / الأطراف المقيدة"
          ]
        },
        {
          "type": "h3",
          "text": "بيانات تقنية واستخدام"
        },
        {
          "type": "p",
          "text": "قد يشمل ذلك:"
        },
        {
          "type": "ul",
          "items": [
            "عنوان IP",
            "نوع المتصفح وإصداره",
            "نوع الجهاز",
            "نظام التشغيل",
            "المنطقة الزمنية وإعدادات الموقع",
            "بيانات استخدام الموقع",
            "الصفحات المعروضة",
            "بيانات تسجيل الدخول",
            "تفضيلات ملفات الارتباط والموافقة",
            "التفاعل مع ميزات الموقع"
          ]
        },
        {
          "type": "h3",
          "text": "بيانات التسويق والتواصل"
        },
        {
          "type": "p",
          "text": "قد يشمل ذلك:"
        },
        {
          "type": "ul",
          "items": [
            "تفضيلات التسويق",
            "تفضيلات التواصل",
            "سجلات البريد وWhatsApp والرسائل القصيرة والهاتف أو النماذج",
            "بيانات تفاعل الحملات"
          ]
        },
        {
          "type": "p",
          "text": "إذا كانت بعض المعلومات إلزامية لخدمة معينة، قد لا نتمكن من تقديم تلك الخدمة إذا لم تُقدَّم المعلومات المطلوبة."
        }
      ]
    },
    {
      "title": "٣. لماذا نستخدم بياناتك الشخصية؟",
      "blocks": [
        {
          "type": "p",
          "text": "نعالج البيانات الشخصية للأغراض التالية:"
        },
        {
          "type": "ul",
          "items": [
            "توفير الوصول إلى موقع وخدمات DeMaxtore",
            "إنشاء وإدارة حسابات المشترين والموردين والشركاء",
            "معالجة طلبات التوريد وRFQ وCommodityBid",
            "مقارنة عروض الشحن ودعم FreightIQ",
            "تنسيق التفتيش وتتبع الشحنات المباشر",
            "التواصل مع المستخدمين والمشترين والموردين وشركاء اللوجستيات",
            "التحقق من معلومات الشركة والمورد والشريك",
            "تقديم دعم العملاء وإدارة علاقات الأعمال",
            "تحسين الموقع والخدمات والبحث وتجربة المستخدم",
            "تخصيص التوصيات ذات الصلة حيث يسمح القانون بذلك",
            "إرسال اتصالات الخدمة والمعاملات والقانونية والتسويقية المسموح بها",
            "منع الاحتيال وإساءة الاستخدام والبريد العشوائي والنشاط غير المصرح به",
            "الامتثال للالتزامات القانونية والضريبية والمحاسبية والتنظيمية والامتثال",
            "حماية حقوق DeMaxtore وسلامتها وسمعتها ومصالحها المشروعة"
          ]
        }
      ]
    },
    {
      "title": "٤. الخدمات المخصصة وإنشاء الملفات",
      "blocks": [
        {
          "type": "p",
          "text": "قد تستخدم DeMaxtore بيانات معينة لتحسين صلة نتائج البحث وتوصيات الموردين ومقارنات الشحن أو اقتراحات التوريد."
        },
        {
          "type": "p",
          "text": "على سبيل المثال، قد نحلل:"
        },
        {
          "type": "ul",
          "items": [
            "استعلامات البحث",
            "اهتمامات المنتج",
            "سجل التوريد",
            "الفئات المطلوبة",
            "تفضيلات البلد أو السوق",
            "سلوك المشتري أو المورد",
            "أنماط استخدام المنصة"
          ]
        },
        {
          "type": "p",
          "text": "قد يساعدنا ذلك في تقديم اقتراحات أكثر صلة للموردين أو الفئات أو خيارات الشحن أو الخدمات."
        },
        {
          "type": "p",
          "text": "حيث يتطلب هذا المعالجة موافقة بموجب القانون المعمول به، سنطلب موافقتك قبل استخدام هذه البيانات."
        },
        {
          "type": "p",
          "text": "لا نستخدم اتخاذ قرار آلي ينتج آثاراً قانونية أو مماثلة مهمة دون تدخل بشري."
        }
      ]
    },
    {
      "title": "٥. الاتصالات التسويقية",
      "blocks": [
        {
          "type": "p",
          "text": "قد نرسل اتصالات تسويقية حول خدمات DeMaxtore، بما في ذلك التوريد وCommodityBid وFreightIQ والتفتيش وتتبع الشحنات وحلول إدارة الاستيراد B2B الأخرى."
        },
        {
          "type": "p",
          "text": "قد تُرسل هذه الاتصالات عبر:"
        },
        {
          "type": "ul",
          "items": [
            "البريد الإلكتروني",
            "WhatsApp",
            "الرسائل القصيرة",
            "الهاتف",
            "قنوات اتصال إلكترونية أخرى"
          ]
        },
        {
          "type": "p",
          "text": "يمكنك إلغاء الاشتراك في أي وقت عبر خيار إلغاء الاشتراك أو بالتواصل معنا على:"
        },
        {
          "type": "p",
          "text": "support@demaxtore.com"
        },
        {
          "type": "p",
          "text": "حتى بعد إلغاء الاشتراك، قد نرسل رسائل مهمة متعلقة بالخدمة أو القانون أو الأمان أو المعاملات."
        }
      ]
    },
    {
      "title": "٦. روابط الأطراف الثالثة",
      "blocks": [
        {
          "type": "p",
          "text": "قد يتضمن موقعنا روابط لمواقع أو أدوات أو إضافات أو تطبيقات أو موردين أو مصنعين أو مقدمي لوجستيات أو شركاء تفتيش أو منصات خارجية."
        },
        {
          "type": "p",
          "text": "النقر على روابط الأطراف الثالثة أو تفعيل التكاملات قد يسمح لهم بجمع أو معالجة بيانات عنك."
        },
        {
          "type": "p",
          "text": "لا تتحكم DeMaxtore في مواقع الأطراف الثالثة ولا تتحمل مسؤولية ممارسات الخصوصية لديهم. نوصي بمراجعة إشعارات الخصوصية وسياسات ملفات الارتباط لتلك المواقع."
        }
      ]
    },
    {
      "title": "٧. ملفات الارتباط وإدارة الموافقة",
      "blocks": [
        {
          "type": "p",
          "text": "نستخدم ملفات الارتباط وتقنيات مماثلة على www.demaxtore.com من أجل:"
        },
        {
          "type": "ul",
          "items": [
            "ضمان عمل الموقع",
            "تذكر تفضيلات ملفات الارتباط",
            "تحسين الأداء",
            "تحليل حركة الموقع",
            "تحسين تجربة المستخدم",
            "دعم التسويق والإعلان"
          ]
        },
        {
          "type": "p",
          "text": "حيث يقتضي القانون ذلك، نطلب موافقتك قبل وضع ملفات ارتباط غير ضرورية على جهازك."
        },
        {
          "type": "p",
          "text": "يمكنك قبول ملفات الارتباط أو رفضها أو إدارة تفضيلاتك عبر شريط ملفات الارتباط أو أداة التفضيلات."
        },
        {
          "type": "p",
          "text": "لمزيد من التفاصيل، راجع سياسة ملفات الارتباط المنفصلة."
        }
      ]
    },
    {
      "title": "٨. مع من نشارك بياناتك الشخصية؟",
      "blocks": [
        {
          "type": "p",
          "text": "قد نشارك بياناتك الشخصية مع:"
        },
        {
          "type": "ul",
          "items": [
            "المشترين",
            "الموردين",
            "المصنعين",
            "وسطاء الشحن",
            "مقدمي الخدمات اللوجستية",
            "مقدمي خدمات التفتيش",
            "شركاء الجمارك أو المستندات أو التجارة",
            "مقدمي تقنية المعلومات والاستضافة وCRM والتحليلات والبريد والسحابة",
            "مقدمي التسويق والاتصالات",
            "مستشارين قانونيين ومحاسبين ومراجعة وامتثال",
            "بنوك أو مقدمي دفع عند الضرورة",
            "سلطات عامة أو محاكم أو جهات تنظيمية أو إنفاذ قانون عند الاقتضاء"
          ]
        },
        {
          "type": "p",
          "text": "نشارك البيانات فقط عند الضرورة للأغراض الموضحة في هذا الإشعار أو عندما يقتضي القانون ذلك."
        },
        {
          "type": "p",
          "text": "لا نبيع البيانات الشخصية."
        }
      ]
    },
    {
      "title": "٩. النقل الدولي للبيانات",
      "blocks": [
        {
          "type": "p",
          "text": "لأن DeMaxtore تعمل في التجارة الدولية، قد تُنقل بياناتك أو يُمكن الوصول إليها من خارج بلد إقامتك."
        },
        {
          "type": "p",
          "text": "حيث يقتضي القانون، نستخدم ضمانات مناسبة تشمل تدابير تعاقدية وتقنية وتنظيمية أو آليات نقل مشروعة أخرى."
        }
      ]
    },
    {
      "title": "١٠. كم مدة احتفاظنا ببياناتك؟",
      "blocks": [
        {
          "type": "p",
          "text": "نحتفظ بالبيانات الشخصية فقط للمدة اللازمة للأغراض الموضحة في هذا الإشعار."
        },
        {
          "type": "p",
          "text": "قد تعتمد مدة الاحتفاظ على:"
        },
        {
          "type": "ul",
          "items": [
            "نوع البيانات",
            "غرض المعالجة",
            "مدة علاقة الأعمال",
            "الالتزامات القانونية والضريبية والمحاسبية والتنظيمية",
            "متطلبات حل النزاعات",
            "احتياجات منع الاحتيال والأمان"
          ]
        },
        {
          "type": "p",
          "text": "عندما لا تعود مطلوبة، نحذفها أو نجهلها أو نؤرشفها بشكل آمن."
        }
      ]
    },
    {
      "title": "١١. كيف نحمي بياناتك؟",
      "blocks": [
        {
          "type": "p",
          "text": "نستخدم تدابير تقنية وتنظيمية معقولة لحماية البيانات من:"
        },
        {
          "type": "ul",
          "items": [
            "الوصول غير المصرح به",
            "الفقد",
            "إساءة الاستخدام",
            "التعديل",
            "الإفصاح",
            "الإتلاف",
            "النشاط الاحتيالي",
            "حوادث الأمن"
          ]
        },
        {
          "type": "p",
          "text": "لا يمكن ضمان أن أي خدمة عبر الإنترنت آمنة بالكامل. يتحمل المستخدمون مسؤولية سرية بيانات الدخول وإبلاغنا فور الاشتباه في وصول غير مصرح به."
        }
      ]
    },
    {
      "title": "١٢. حقوقك",
      "blocks": [
        {
          "type": "p",
          "text": "بحسب قوانين حماية البيانات المعمول بها، قد يكون لك الحق في:"
        },
        {
          "type": "ul",
          "items": [
            "الوصول إلى بياناتك",
            "طلب التصحيح",
            "طلب الحذف",
            "الاعتراض على معالجة معينة",
            "طلب تقييد المعالجة",
            "سحب الموافقة",
            "طلب نقل البيانات",
            "تقديم شكوى لسلطة مختصة"
          ]
        },
        {
          "type": "p",
          "text": "لممارسة حقوقك، تواصل معنا على:"
        },
        {
          "type": "p",
          "text": "support@demaxtore.com"
        },
        {
          "type": "p",
          "text": "قد نحتاج للتحقق من هويتك قبل الرد."
        }
      ]
    },
    {
      "title": "١٣. WhatsApp وقنوات التواصل الأخرى",
      "blocks": [
        {
          "type": "p",
          "text": "إذا تواصلت معنا عبر WhatsApp أو البريد الإلكتروني أو الرسائل القصيرة أو الهاتف أو قنوات أخرى، قد نعالج ونخزن محتوى التواصل ومعلومات الاتصال ذات الصلة."
        },
        {
          "type": "p",
          "text": "يساعدنا ذلك على:"
        },
        {
          "type": "ul",
          "items": [
            "الرد على طلبك",
            "تقديم الدعم",
            "إدارة علاقات المشتري والمورد والشريك",
            "تنسيق التوريد أو الشحن أو التفتيش أو الشحنات",
            "الاحتفاظ بسجلات الأعمال"
          ]
        },
        {
          "type": "p",
          "text": "قد تعالج أدوات التواصل التابعة لطرف ثالث بياناتك وفق سياساتها الخاصة."
        }
      ]
    },
    {
      "title": "١٤. المعاملات التجارية",
      "blocks": [
        {
          "type": "p",
          "text": "إذا شاركت DeMaxtore في اندماج أو استحواذ أو استثمار أو إعادة هيكلة أو بيع أصول أو معاملة مماثلة، قد تُنقل البيانات الشخصية أو تُفصح كجزء من تلك المعاملة حيث يسمح القانون بذلك."
        },
        {
          "type": "p",
          "text": "في هذه الحالة، سنتخذ تدابير مناسبة لحماية البيانات."
        }
      ]
    },
    {
      "title": "١٥. بيانات الأطفال",
      "blocks": [
        {
          "type": "p",
          "text": "تقدم DeMaxtore خدمات B2B ولا تستهدف الأطفال."
        },
        {
          "type": "p",
          "text": "لا نجمع عن قصد بيانات من أشخاص دون ١٨ عاماً. إذا علمنا بذلك، سنتخذ خطوات معقولة لحذفها."
        }
      ]
    },
    {
      "title": "١٦. تحديثات إشعار خصوصية الموقع",
      "blocks": [
        {
          "type": "p",
          "text": "قد نحدّث إشعار خصوصية الموقع هذا لتعكس تغييرات في خدماتنا أو المتطلبات القانونية أو العمليات أو ممارسات المعالجة."
        },
        {
          "type": "p",
          "text": "سيُنشر أحدث إصدار على www.demaxtore.com مع تاريخ التحديث."
        }
      ]
    },
    {
      "title": "١٧. اتصل بنا",
      "blocks": [
        {
          "type": "p",
          "text": "لأي أسئلة أو طلبات أو مخاوف بشأن إشعار الخصوصية هذا أو كيفية معالجة البيانات الشخصية، تواصل معنا:"
        },
        {
          "type": "ul",
          "items": [
            "Demakstore Gıda İhracat San. ve Tic. Ltd. Şti.",
            "العلامة التشغيلية: DeMaxtore",
            "الموقع: www.demaxtore.com",
            "البريد الإلكتروني: support@demaxtore.com",
            "بريد إلكتروني بديل: demaxtore@demaxtore.com"
          ]
        }
      ]
    }
  ]
};
